
import { IScene, Scene } from "@/scenes/models";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Typewriter from './Typewriter.vue'
import Inventory from './Inventory.vue'
import PinPad from './ATM.vue'

@Component({
  components: {
    Typewriter,
    Inventory,
    PinPad
  }
})
export default class Loading extends Vue {
  @Prop() 
  loading!: boolean;

  @Prop()
  scene!: Scene;

  @Prop()
  scenes!: Record<string, () => Promise<IScene>>;

  @Watch('scene.isRunningDialog')
  async focusDefaultButton(isRunningDialog: string, oldValue: string) {
    await Vue.nextTick()
    if(isRunningDialog && this.$refs.defaultButton) {
      (this.$refs.defaultButton as HTMLButtonElement).focus()
    }
  }

  get audio() {
    try {
      return this.scene ? this.scene.audio : null;
    } catch {
      return "";
    }
  }

  async action(i: number) {
    this.scene.key = Math.random();
    await this.scene.options[i].action();
  }
  
  get options() {
    return this.scene.options
  }

  sound = false;  

  setSound(sound: boolean) {
    this.sound = sound;
    localStorage.sound = sound;
  }

  mounted() {
    this.sound =  localStorage.sound === 'true'
  }
}
